// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + __webpack_require__.h() + "-03-12-2025/chunk/" + chunkId + ".js"
}